import { render, staticRenderFns } from "./acknowledgeFunding.vue?vue&type=template&id=3630af64&"
import script from "./acknowledgeFunding.vue?vue&type=script&lang=js&"
export * from "./acknowledgeFunding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports